<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div
        class="page-title-box d-sm-flex align-items-center justify-content-between"
      >
        <app-rp-breadcrumb
          [breadcrumbItems]="breadCrumbItems"
        ></app-rp-breadcrumb>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <!-- <h4 class="card-title mb-4">Project Details</h4> -->
          <div id="basic-example">
            <section class="p-2">
              <form>
                <!-- <div class="row mb-2 d-sm-block">
                  <h4 class="card-title mb-4 text-decoration-underline">Project Details</h4>
                </div> -->
                <div class="row">
                  <div class="col-lg-3" *ngIf="viewDetails?.projectName">
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">Project Name</label>
                      <p>{{ viewDetails?.projectName }}</p>
                    </div>
                  </div>

                  <div
                    class="col-lg-3"
                    *ngIf="
                      type === 'EV Reading Details' ||
                      viewDetails?.deviceSRNO
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">Device Sr No</label>
                      <p>{{ displayValue(viewDetails?.deviceSRNO) }}</p>
                    </div>
                  </div>

                  <div class="col-lg-3" *ngIf="viewDetails?.macAddress">
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">Mac Address</label>
                      <p>{{ viewDetails?.macAddress }}</p>
                    </div>
                  </div>

                  <div class="col-lg-3" *ngIf="viewDetails?.utilityType">
                    <div class="mb-4">
                      <label for="">Utility Type</label>
                      <p>{{ viewDetails?.utilityType }}</p>
                    </div>
                  </div>
                  <!-- <div class="col-lg-3" *ngIf="viewDetails?.onOffStatus">
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">On/Off Status</label>
                      <p>{{ viewDetails?.onOffStatus }}</p>
                    </div>
                  </div> -->
                  <div
                    class="col-lg-3"
                    *ngIf="
                      viewDetails?.utilityType == 'Water' ||
                      viewDetails?.utilityType == 'Gas'
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input"
                        >Meter Reading</label
                      >
                      <p>{{ viewDetails?.meterReading }}</p>
                    </div>
                  </div>
                  <div
                    class="col-lg-3"
                    *ngIf="
                      viewDetails?.meterReadingDG != null &&
                      (viewDetails?.utilityType == 'Electricity' ||
                        viewDetails?.utilityType == 'TriSource')
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input"
                        >Meter ReadingDG</label
                      >
                      <p>{{ viewDetails?.meterReadingDG }}</p>
                    </div>
                  </div>
                  <div
                    class="col-lg-3"
                    *ngIf="
                      viewDetails?.meterReadingEB != null &&
                      (viewDetails?.utilityType == 'Electricity' ||
                        viewDetails?.utilityType == 'TriSource')
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input"
                        >Meter ReadingEB</label
                      >
                      <p>{{ viewDetails?.meterReadingEB }}</p>
                    </div>
                  </div>
                  <div
                    class="col-lg-3"
                    *ngIf="
                      viewDetails?.meterReadingTS != null &&
                      (viewDetails?.utilityType == 'Electricity' ||
                        viewDetails?.utilityType == 'TriSource')
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">Solar</label>
                      <p>{{ viewDetails?.meterReadingTS }}</p>
                    </div>
                  </div>

                  <div
                    class="col-lg-3"
                    *ngIf="viewDetails?.onOffStatus != null"
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">Meter On/Off</label>
                      <p>{{ viewDetails?.onOffStatus }}</p>
                    </div>
                  </div>

                  <!-- <div class="col-lg-3" *ngIf="viewDetails?.devicesSRNO">
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">
                        {{ type === 'Reading Details' ? 'Devices SR NO' : 'Device Address' }}
                      </label>
                      <p>{{ viewDetails?.devicesSRNO }}</p>
                    </div>
                  </div> -->

                  <div class="col-lg-3" *ngIf="viewDetails?.date_Time">
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">Date</label>
                      <p>
                        {{
                          viewDetails?.date_Time | date: "dd/MM/yyyy hh:mm a"
                        }}
                      </p>
                    </div>
                  </div>

                  <div
                    class="col-lg-3"
                    *ngIf="
                      type === 'EV Reading Details' &&
                      viewDetails?.startDate &&
                      viewDetails?.startDate !== '-'
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">Start Date</label>
                      <p>
                        {{
                          viewDetails?.startDate | date: "dd/MM/yyyy hh:mm a"
                        }}
                      </p>
                    </div>
                  </div>

                  <div
                    class="col-lg-3"
                    *ngIf="
                      type === 'EV Reading Details' &&
                      viewDetails?.endDate &&
                      viewDetails?.endDate !== '-'
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">End Date</label>
                      <p>
                        {{ viewDetails?.endDate | date: "dd/MM/yyyy hh:mm a" }}
                      </p>
                    </div>
                  </div>

                  <div
                    class="col-lg-3"
                    *ngIf="
                      type === 'EV Reading Details' &&
                      viewDetails?.unitRate !== null &&
                      viewDetails?.unitRate !== undefined &&
                      viewDetails?.unitRate !== ''
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">Unit Rate (₹)</label>
                      <p>{{ viewDetails?.unitRate }}</p>
                    </div>
                  </div>

                  <div
                    class="col-lg-3"
                    *ngIf="
                      type === 'EV Reading Details' &&
                      viewDetails?.amount !== null &&
                      viewDetails?.amount !== undefined &&
                      viewDetails?.amount !== ''
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">Amount (₹)</label>
                      <p>{{ viewDetails?.amount }}</p>
                    </div>
                  </div>

                  <div
                    class="col-lg-3"
                    *ngIf="
                      type === 'EV Reading Details' &&
                      viewDetails?.noOfUnits !== null &&
                      viewDetails?.noOfUnits !== undefined &&
                      viewDetails?.noOfUnits !== ''
                    "
                  >
                    <div class="mb-4">
                      <label for="basicpill-lastname-input">No. Of Units (kWh)</label>
                      <p>{{ viewDetails?.noOfUnits }}</p>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="row">
                      <div
                        class="col-lg-6"
                        *ngIf="
                          viewDetails?.rawJson !== null &&
                          viewDetails?.rawJson !== undefined
                        "
                      >
                        <div class="mb-4">
                          <label for="basicpill-lastname-input">Raw JSON</label>
                          <div
                            style="
                              max-height: 300px;
                              overflow-y: auto;
                              border: 1px solid #ccc;
                              padding: 10px;
                              background-color: #f9f9f9;
                            "
                          >
                            <pre>{{ viewDetails?.rawJson | json }}</pre>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-lg-6"
                        *ngIf="
                          viewDetails?.convertedJson !== null &&
                          viewDetails?.convertedJson !== undefined
                        "
                      >
                        <div class="mb-4">
                          <label for="basicpill-lastname-input"
                            >Converted JSON</label
                          >
                          <div
                            style="
                              max-height: 300px;
                              overflow-y: auto;
                              border: 1px solid #ccc;
                              padding: 10px;
                              background-color: #f9f9f9;
                            "
                          >
                            <pre>{{ viewDetails?.convertedJson | json }}</pre>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </section>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </div>
</div>
